import { MenuItem, Select } from "@mui/material";
import { ReactElement, useState } from "react";

interface IMenuListProps {
  menuItems: Array<{ label: string; value: string; isDisabled?: boolean }>;
  filterHandler: (event: string) => void;
  defaultValue: string;
}

export const MenuList: React.FC<IMenuListProps> = ({
  menuItems,
  filterHandler,
  defaultValue,
}) => {
  const [selectedFilter, setSelectedFilter] = useState<string>(defaultValue);
  const onChangeHandler = (event: any) => {
    setSelectedFilter(event.target.value);
    filterHandler(event.target.value);
  };

  return (
    <Select
      size="small"
      value={selectedFilter}
      onChange={onChangeHandler}
      sx={{ minWidth: 160, borderRadius: "50px", fontSize: "14px" }}
    >
      {menuItems.map((item) => (
        <MenuItem value={item.value} disabled={item.isDisabled}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
};
